import type { GridProps } from "@dealer-center/core-components";
import { Grid } from "@dealer-center/core-components";

export const GridOfInputs = (props: GridProps) => (
  <Grid size={{ lg: 2, md: 3, sm: 6, xs: 12 }} {...props} />
);
